import React from 'react';
import Cover from '../partials/Cover';
import Login from '../partials/Login';
import CartModal from '../partials/CartModal';
import Head from '../partials/Head';
import Page from '../partials/Page';
import Article from '../partials/Article';
import Articles from '../partials/Articles';
import Collection from '../partials/Collection';
import Product from '../partials/Product';
import Register from '../partials/Register';
import Account from '../partials/Account';
import AccountSettings from '../partials/AccountSettings';
import Lampshades from '../partials/Lampshades';
import {Provider} from '../context/Context'
import { ParallaxProvider } from 'react-scroll-parallax';

const TplIndex = (props) => {  
	
	console.log('props.match.path: ' + props.match.path);
	let block = null;
	if (props.match.path === "/https:slug" || props.match.path === "/http:slug") {
		let redirect = props.location.pathname.substring(1);
		window.location.href = redirect;
		return null;
	} else {
		if (props.match.path === "/:slug" || props.match.path === "/") {
			block = <Page></Page>;
		} else if (props.match.path === '/collection/:slug' || props.match.path === '/product-category/:slug' || props.match.path === '/designer/:slug' || props.match.path === '/search/:slug') {
			block = <Collection></Collection>;
		} else if (props.match.path === '/product/:slug') {
			block = <Product></Product>;
		} else if (props.match.path === '/news/:slug') {
			block = <Article></Article>;
		} else if (props.match.path === '/news-category/:slug') {
			block = <Articles></Articles>;
		} else if (props.match.path === '/news/') {
			block = <Articles></Articles>;
		} else if (props.match.path === '/customer-registration/') {
			block = <Register></Register>;
		} else if (props.match.path === '/lampshades-made-to-measure/') {
			block = <Lampshades></Lampshades>;
		} else if (props.match.path === '/account/' || props.match.path === '/account/details/' || props.match.path === '/account/quote-requests/') {
			block = <Account></Account>;
		}
	    
		return (
			<Provider router={props}>
				<Cover></Cover>
				<Login></Login>
				<CartModal></CartModal>
				<ParallaxProvider>
					<div className="c-site-wrapper">
						<Head></Head>
						{ block }
					</div>
				</ParallaxProvider>
			</Provider>
		)    
	}
}
export default TplIndex